import React, { useState, useEffect, useRef } from 'react';
import { 
    FaTimes, FaSave, FaEye, FaPlus, FaTrash, FaArrowUp, FaArrowDown,
    FaHeading, FaFont, FaImage, FaLink, FaMinus, FaArrowsAltV,
    FaPalette, FaAlignLeft, FaAlignCenter, FaAlignRight,
    FaBold, FaItalic, FaUnderline, FaListUl, FaListOl, FaEdit, FaCheck,
    FaCode, FaCubes
} from 'react-icons/fa';
import { templateAPI } from './campaignService';

const styles = {
    container: {
        display: 'flex',
        height: '85vh',
        background: '#1e293b'
    },
    sidebar: {
        width: '320px',
        background: '#0f172a',
        borderRight: '1px solid rgba(255, 255, 255, 0.1)',
        padding: '20px',
        overflowY: 'auto'
    },
    editor: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '16px 24px',
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
        background: '#1e293b'
    },
    headerTitle: {
        color: '#FFFFFF',
        fontSize: '18px',
        fontWeight: '600',
        margin: 0
    },
    headerActions: {
        display: 'flex',
        gap: '12px'
    },
    btn: {
        padding: '10px 20px',
        borderRadius: '8px',
        border: 'none',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: '500',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        transition: 'all 0.2s ease'
    },
    primaryBtn: {
        background: 'linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)',
        color: '#FFFFFF'
    },
    secondaryBtn: {
        background: 'rgba(100, 116, 139, 0.2)',
        border: '1px solid rgba(100, 116, 139, 0.4)',
        color: '#94A3B8'
    },
    closeBtn: {
        background: 'transparent',
        border: 'none',
        color: '#94A3B8',
        fontSize: '20px',
        cursor: 'pointer',
        padding: '8px'
    },
    canvas: {
        flex: 1,
        overflowY: 'auto',
        padding: '24px',
        background: '#374151',
        display: 'flex',
        justifyContent: 'center'
    },
    emailPreview: {
        width: '600px',
        background: '#FFFFFF',
        borderRadius: '8px',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
        overflow: 'hidden'
    },
    sectionTitle: {
        fontSize: '12px',
        fontWeight: '600',
        color: 'rgba(255, 255, 255, 0.5)',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        marginBottom: '12px'
    },
    blockType: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        padding: '12px',
        background: 'rgba(100, 116, 139, 0.1)',
        borderRadius: '8px',
        marginBottom: '8px',
        cursor: 'pointer',
        color: '#94A3B8',
        transition: 'all 0.2s ease',
        border: '1px solid transparent'
    },
    input: {
        width: '100%',
        padding: '12px',
        background: 'rgba(0, 0, 0, 0.3)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        borderRadius: '8px',
        color: '#FFFFFF',
        fontSize: '14px',
        marginBottom: '12px',
        boxSizing: 'border-box'
    },
    textarea: {
        width: '100%',
        padding: '12px',
        background: 'rgba(0, 0, 0, 0.3)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        borderRadius: '8px',
        color: '#FFFFFF',
        fontSize: '14px',
        marginBottom: '12px',
        minHeight: '120px',
        resize: 'vertical',
        fontFamily: 'inherit',
        boxSizing: 'border-box',
        lineHeight: '1.6'
    },
    label: {
        display: 'block',
        fontSize: '13px',
        color: 'rgba(255, 255, 255, 0.7)',
        marginBottom: '6px'
    },
    colorInput: {
        width: '100%',
        height: '40px',
        padding: '4px',
        background: 'rgba(0, 0, 0, 0.3)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        borderRadius: '8px',
        cursor: 'pointer',
        marginBottom: '12px'
    },
    blockItem: {
        background: 'rgba(0, 0, 0, 0.2)',
        borderRadius: '8px',
        marginBottom: '8px',
        border: '1px solid rgba(255, 255, 255, 0.05)',
        overflow: 'hidden'
    },
    blockHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '12px',
        background: 'rgba(0, 0, 0, 0.2)',
        cursor: 'pointer'
    },
    blockActions: {
        display: 'flex',
        gap: '4px'
    },
    iconBtn: {
        background: 'transparent',
        border: 'none',
        color: '#94A3B8',
        cursor: 'pointer',
        padding: '4px',
        fontSize: '12px'
    },
    blockContent: {
        padding: '12px'
    },
    prebuiltGrid: {
        display: 'grid',
        gridTemplateColumns: '1fr',
        gap: '12px',
        marginBottom: '24px'
    },
    prebuiltCard: {
        background: 'rgba(100, 116, 139, 0.1)',
        borderRadius: '8px',
        padding: '16px',
        cursor: 'pointer',
        border: '1px solid rgba(255, 255, 255, 0.05)',
        transition: 'all 0.2s ease'
    },
    prebuiltName: {
        fontSize: '14px',
        fontWeight: '600',
        color: '#FFFFFF',
        marginBottom: '4px'
    },
    prebuiltDesc: {
        fontSize: '12px',
        color: 'rgba(255, 255, 255, 0.6)'
    },
    alignBtns: {
        display: 'flex',
        gap: '4px',
        marginBottom: '12px'
    },
    alignBtn: {
        flex: 1,
        padding: '8px',
        background: 'rgba(0, 0, 0, 0.3)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        borderRadius: '6px',
        color: '#94A3B8',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    alignBtnActive: {
        background: 'rgba(139, 92, 246, 0.2)',
        borderColor: '#8b5cf6',
        color: '#8b5cf6'
    },
    editableBlock: {
        position: 'relative',
        cursor: 'pointer',
        transition: 'all 0.2s ease'
    },
    editableBlockHover: {
        outline: '2px dashed #8b5cf6',
        outlineOffset: '2px'
    },
    editableBlockSelected: {
        outline: '2px solid #8b5cf6',
        outlineOffset: '2px'
    },
    toolbar: {
        display: 'flex',
        gap: '4px',
        padding: '8px',
        background: 'rgba(0, 0, 0, 0.4)',
        borderRadius: '6px',
        marginBottom: '8px'
    },
    toolbarBtn: {
        padding: '6px 10px',
        background: 'rgba(100, 116, 139, 0.2)',
        border: '1px solid rgba(100, 116, 139, 0.3)',
        borderRadius: '4px',
        color: '#FFFFFF',
        cursor: 'pointer',
        fontSize: '12px',
        display: 'flex',
        alignItems: 'center',
        gap: '4px'
    },
    placeholderHint: {
        background: 'rgba(139, 92, 246, 0.1)',
        border: '1px solid rgba(139, 92, 246, 0.3)',
        borderRadius: '6px',
        padding: '10px 12px',
        marginBottom: '12px',
        fontSize: '12px',
        color: '#8b5cf6'
    },
    imagePreview: {
        width: '100%',
        maxHeight: '150px',
        objectFit: 'contain',
        borderRadius: '6px',
        marginBottom: '12px',
        background: 'rgba(0,0,0,0.2)'
    }
};

const BLOCK_TYPES = [
    { type: 'header', icon: FaHeading, label: 'Header' },
    { type: 'text', icon: FaFont, label: 'Text Block' },
    { type: 'image', icon: FaImage, label: 'Image' },
    { type: 'button', icon: FaLink, label: 'Button' },
    { type: 'divider', icon: FaMinus, label: 'Divider' },
    { type: 'spacer', icon: FaArrowsAltV, label: 'Spacer' }
];

const PREBUILT_TEMPLATES = [
    {
        id: 'announcement-important',
        name: 'Important Announcement',
        description: 'For urgent updates and critical information',
        category: 'announcement'
    },
    {
        id: 'newsletter-monthly',
        name: 'Monthly Newsletter',
        description: 'Regular updates and news digest',
        category: 'newsletter'
    },
    {
        id: 'reminder-action',
        name: 'Action Reminder',
        description: 'Remind users to complete an action',
        category: 'reminder'
    },
    {
        id: 'notification-status',
        name: 'Status Update',
        description: 'Notify users about case or application status',
        category: 'notification'
    },
    {
        id: 'welcome-new-user',
        name: 'Welcome Email',
        description: 'Welcome new users to your service',
        category: 'notification'
    }
];

// HTML Starter Template for HTML Mode
const HTML_STARTER_TEMPLATE = `<!-- 
  Email Template - Edit this HTML as needed
  Placeholders available: {{userName}}, {{expertName}}, {{actionUrl}}, {{unsubscribeLink}}
-->

<div style="padding: 40px 30px; background: linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%); text-align: center;">
  <h1 style="color: #ffffff; margin: 0; font-size: 28px; font-weight: 600;">
    Welcome, {{userName}}!
  </h1>
  <p style="color: rgba(255,255,255,0.9); margin: 12px 0 0 0; font-size: 16px;">
    Your email subtitle here
  </p>
</div>

<div style="padding: 30px;">
  <p style="font-size: 16px; color: #374151; line-height: 1.6;">
    Hello {{userName}},
  </p>
  
  <p style="font-size: 16px; color: #374151; line-height: 1.6;">
    Write your message here. You can use any HTML you want to create 
    your perfect email template.
  </p>
  
  <div style="text-align: center; margin: 30px 0;">
    <a href="{{actionUrl}}" 
       style="display: inline-block; 
              background: linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%);
              color: #ffffff; 
              padding: 14px 32px; 
              text-decoration: none; 
              border-radius: 8px; 
              font-weight: 600;">
      Take Action
    </a>
  </div>
  
  <p style="font-size: 16px; color: #374151; line-height: 1.6;">
    Best regards,<br/>
    {{expertName}}
  </p>
</div>`;

// Simple text to HTML converter (preserves line breaks, basic formatting)
const textToHtml = (text) => {
    if (!text) return '';
    return text
        .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
        .replace(/\*(.*?)\*/g, '<em>$1</em>')
        .replace(/__(.*?)__/g, '<u>$1</u>')
        .split('\n')
        .map(line => `<p style="font-size: 16px; color: #374151; line-height: 1.6; margin: 0 0 12px 0;">${line || '&nbsp;'}</p>`)
        .join('');
};

// HTML to simple text converter (for editing)
const htmlToText = (html) => {
    if (!html) return '';
    return html
        .replace(/<strong>(.*?)<\/strong>/g, '**$1**')
        .replace(/<b>(.*?)<\/b>/g, '**$1**')
        .replace(/<em>(.*?)<\/em>/g, '*$1*')
        .replace(/<i>(.*?)<\/i>/g, '*$1*')
        .replace(/<u>(.*?)<\/u>/g, '__$1__')
        .replace(/<p[^>]*>/g, '')
        .replace(/<\/p>/g, '\n')
        .replace(/<br\s*\/?>/g, '\n')
        .replace(/<[^>]+>/g, '')
        .replace(/&nbsp;/g, '')
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .trim();
};

const createBlock = (type, order) => {
    const id = `block-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    
    const defaultContent = {
        header: {
            title: 'Your Email Title',
            subtitle: 'Add a subtitle here',
            backgroundColor: '#8b5cf6'
        },
        text: {
            text: 'Write your message here.\n\nYou can use **bold**, *italic*, and __underline__ formatting.\n\nUse placeholders like {{userName}} and {{expertName}} to personalize the email.',
            textAlign: 'left'
        },
        image: {
            imageUrl: '',
            altText: 'Image description',
            width: '100%'
        },
        button: {
            buttonText: 'Click Here',
            buttonUrl: '{{actionUrl}}',
            buttonColor: '#8b5cf6',
            buttonTextColor: '#ffffff',
            buttonAlign: 'center'
        },
        divider: {
            dividerColor: '#e5e7eb'
        },
        spacer: {
            height: '24px'
        }
    };

    return {
        id,
        type,
        order,
        content: defaultContent[type] || {}
    };
};

const TemplateBuilder = ({ expertId, template, onClose, onSave }) => {
    const [name, setName] = useState('');
    const [subject, setSubject] = useState('');
    const [category, setCategory] = useState('custom');
    const [blocks, setBlocks] = useState([]);
    const [globalStyles, setGlobalStyles] = useState({
        primaryColor: '#8b5cf6',
        backgroundColor: '#f3f4f6',
        fontFamily: 'Arial, sans-serif'
    });
    const [selectedBlock, setSelectedBlock] = useState(null);
    const [showPreview, setShowPreview] = useState(false);
    const [previewHtml, setPreviewHtml] = useState('');
    const [saving, setSaving] = useState(false);
    const [mode, setMode] = useState(template ? 'edit' : 'select');
    const [hoveredBlock, setHoveredBlock] = useState(null);
    const [editorMode, setEditorMode] = useState('blocks'); // 'blocks' or 'html'
    const [rawHtml, setRawHtml] = useState('');

    useEffect(() => {
        if (template) {
            setName(template.name || '');
            setSubject(template.subject || '');
            setCategory(template.category || 'custom');
            
            // Check if template has raw HTML stored
            if (template.rawHtml) {
                setRawHtml(template.rawHtml);
                setEditorMode('html');
                setBlocks([]);
            } else {
                // Convert HTML back to text format for editing
                const convertedBlocks = (template.blocks || []).map(block => {
                    if (block.type === 'text' && block.content.html) {
                        return {
                            ...block,
                            content: {
                                ...block.content,
                                text: htmlToText(block.content.html)
                            }
                        };
                    }
                    return block;
                });
                setBlocks(convertedBlocks);
                setEditorMode('blocks');
            }
            
            setGlobalStyles(template.globalStyles || {
                primaryColor: '#8b5cf6',
                backgroundColor: '#f3f4f6',
                fontFamily: 'Arial, sans-serif'
            });
            setMode('edit');
        }
    }, [template]);

    const handleSelectPrebuilt = async (prebuiltId) => {
        try {
            const newTemplate = await templateAPI.createFromPrebuilt(expertId, prebuiltId, {});
            setName(newTemplate.name);
            setSubject(newTemplate.subject);
            setCategory(newTemplate.category);
            // Convert HTML back to text format
            const convertedBlocks = (newTemplate.blocks || []).map(block => {
                if (block.type === 'text' && block.content.html) {
                    return {
                        ...block,
                        content: {
                            ...block.content,
                            text: htmlToText(block.content.html)
                        }
                    };
                }
                return block;
            });
            setBlocks(convertedBlocks);
            setGlobalStyles(newTemplate.globalStyles);
            setMode('edit');
        } catch (error) {
            console.error('Error creating from prebuilt:', error);
            alert('Failed to load template');
        }
    };

    const handleAddBlock = (type) => {
        const newBlock = createBlock(type, blocks.length);
        setBlocks([...blocks, newBlock]);
        setSelectedBlock(newBlock.id);
    };

    const handleDeleteBlock = (blockId) => {
        setBlocks(blocks.filter(b => b.id !== blockId));
        if (selectedBlock === blockId) {
            setSelectedBlock(null);
        }
    };

    const handleMoveBlock = (blockId, direction) => {
        const index = blocks.findIndex(b => b.id === blockId);
        if ((direction === 'up' && index === 0) || (direction === 'down' && index === blocks.length - 1)) {
            return;
        }

        const newBlocks = [...blocks];
        const newIndex = direction === 'up' ? index - 1 : index + 1;
        [newBlocks[index], newBlocks[newIndex]] = [newBlocks[newIndex], newBlocks[index]];
        
        newBlocks.forEach((block, i) => {
            block.order = i;
        });
        
        setBlocks(newBlocks);
    };

    const handleUpdateBlock = (blockId, updates) => {
        setBlocks(blocks.map(block => 
            block.id === blockId 
                ? { ...block, content: { ...block.content, ...updates } }
                : block
        ));
    };

    const handleSave = async () => {
        if (!name.trim() || !subject.trim()) {
            alert('Please enter a name and subject for your template');
            return;
        }

        // Validate HTML mode has content
        if (editorMode === 'html' && !rawHtml.trim()) {
            alert('Please enter your HTML template content');
            return;
        }

        setSaving(true);
        try {
            let templateData;
            
            if (editorMode === 'html') {
                // HTML mode - store raw HTML
                templateData = {
                    name,
                    subject,
                    category,
                    rawHtml: rawHtml,
                    blocks: [], // Empty blocks for HTML mode
                    globalStyles,
                    isDraft: false
                };
            } else {
                // Block mode - convert text blocks to HTML for storage
                const blocksWithHtml = blocks.map(block => {
                    if (block.type === 'text') {
                        return {
                            ...block,
                            content: {
                                ...block.content,
                                html: textToHtml(block.content.text || '')
                            }
                        };
                    }
                    return block;
                });

                templateData = {
                    name,
                    subject,
                    category,
                    blocks: blocksWithHtml,
                    globalStyles,
                    isDraft: false
                };
            }

            if (template?._id) {
                await templateAPI.updateTemplate(expertId, template._id, templateData);
            } else {
                await templateAPI.createTemplate(expertId, templateData);
            }

            onSave();
        } catch (error) {
            console.error('Error saving template:', error);
            alert('Failed to save template');
        } finally {
            setSaving(false);
        }
    };

    const handlePreview = async () => {
        const html = generatePreviewHtml();
        setPreviewHtml(html);
        setShowPreview(true);
    };

    const generatePreviewHtml = () => {
        // If in HTML mode, return the raw HTML directly
        if (editorMode === 'html') {
            return rawHtml;
        }
        
        // Block mode - convert blocks to HTML
        let html = '';
        const sortedBlocks = [...blocks].sort((a, b) => a.order - b.order);

        for (const block of sortedBlocks) {
            html += renderBlockToHtml(block);
        }

        return html;
    };

    const renderBlockToHtml = (block) => {
        const { type, content } = block;

        switch (type) {
            case 'header':
                return `
                    <div style="background: linear-gradient(135deg, ${content.backgroundColor || '#8b5cf6'} 0%, #6d28d9 100%); padding: 40px 30px; text-align: center;">
                        <h1 style="color: #ffffff; margin: 0; font-size: 28px; font-weight: 600;">${content.title || ''}</h1>
                        ${content.subtitle ? `<p style="color: rgba(255,255,255,0.9); margin: 12px 0 0 0; font-size: 16px;">${content.subtitle}</p>` : ''}
                    </div>
                `;
            case 'text':
                const textHtml = textToHtml(content.text || content.html || '');
                return `
                    <div style="padding: 24px 30px; text-align: ${content.textAlign || 'left'};">
                        ${textHtml}
                    </div>
                `;
            case 'button':
                return `
                    <div style="padding: 16px 30px; text-align: ${content.buttonAlign || 'center'};">
                        <a href="${content.buttonUrl || '#'}" 
                           style="display: inline-block; 
                                  background: linear-gradient(135deg, ${content.buttonColor || '#8b5cf6'} 0%, #6d28d9 100%);
                                  color: ${content.buttonTextColor || '#ffffff'}; 
                                  padding: 14px 32px; 
                                  text-decoration: none; 
                                  border-radius: 8px; 
                                  font-weight: 600;
                                  font-size: 16px;">
                            ${content.buttonText || 'Click Here'}
                        </a>
                    </div>
                `;
            case 'image':
                if (!content.imageUrl) {
                    return `
                        <div style="padding: 24px 30px; text-align: center; background: #f3f4f6;">
                            <div style="border: 2px dashed #d1d5db; padding: 40px; border-radius: 8px; color: #9ca3af;">
                                Click to add image URL
                            </div>
                        </div>
                    `;
                }
                return `
                    <div style="padding: 16px 30px;">
                        <img src="${content.imageUrl}" alt="${content.altText || ''}" style="width: ${content.width || '100%'}; max-width: 100%; height: auto; display: block; border-radius: 8px;">
                    </div>
                `;
            case 'divider':
                return `
                    <div style="padding: 16px 30px;">
                        <hr style="border: none; border-top: 1px solid ${content.dividerColor || '#e5e7eb'}; margin: 0;">
                    </div>
                `;
            case 'spacer':
                return `<div style="height: ${content.height || '24px'};"></div>`;
            default:
                return '';
        }
    };

    const renderBlockEditor = (block) => {
        const { type, content } = block;

        switch (type) {
            case 'header':
                return (
                    <div style={styles.blockContent}>
                        <label style={styles.label}>Title</label>
                        <input 
                            type="text"
                            style={styles.input}
                            value={content.title || ''}
                            onChange={(e) => handleUpdateBlock(block.id, { title: e.target.value })}
                            placeholder="Email title"
                        />
                        <label style={styles.label}>Subtitle</label>
                        <input 
                            type="text"
                            style={styles.input}
                            value={content.subtitle || ''}
                            onChange={(e) => handleUpdateBlock(block.id, { subtitle: e.target.value })}
                            placeholder="Subtitle (optional)"
                        />
                        <label style={styles.label}>Background Color</label>
                        <input 
                            type="color"
                            style={styles.colorInput}
                            value={content.backgroundColor || '#8b5cf6'}
                            onChange={(e) => handleUpdateBlock(block.id, { backgroundColor: e.target.value })}
                        />
                    </div>
                );
            case 'text':
                return (
                    <div style={styles.blockContent}>
                        <div style={styles.placeholderHint}>
                            <strong>Formatting Tips:</strong> Use **bold**, *italic*, __underline__<br/>
                            <strong>Placeholders:</strong> {'{{userName}}'}, {'{{expertName}}'}, {'{{actionUrl}}'}
                        </div>
                        <label style={styles.label}>Text Content</label>
                        <textarea 
                            style={styles.textarea}
                            value={content.text || htmlToText(content.html) || ''}
                            onChange={(e) => handleUpdateBlock(block.id, { text: e.target.value })}
                            placeholder="Write your message here..."
                        />
                        <label style={styles.label}>Alignment</label>
                        <div style={styles.alignBtns}>
                            {['left', 'center', 'right'].map(align => (
                                <button
                                    key={align}
                                    style={{
                                        ...styles.alignBtn,
                                        ...(content.textAlign === align ? styles.alignBtnActive : {})
                                    }}
                                    onClick={() => handleUpdateBlock(block.id, { textAlign: align })}
                                >
                                    {align === 'left' && <FaAlignLeft />}
                                    {align === 'center' && <FaAlignCenter />}
                                    {align === 'right' && <FaAlignRight />}
                                </button>
                            ))}
                        </div>
                    </div>
                );
            case 'button':
                return (
                    <div style={styles.blockContent}>
                        <label style={styles.label}>Button Text</label>
                        <input 
                            type="text"
                            style={styles.input}
                            value={content.buttonText || ''}
                            onChange={(e) => handleUpdateBlock(block.id, { buttonText: e.target.value })}
                            placeholder="Click Here"
                        />
                        <label style={styles.label}>Button URL</label>
                        <input 
                            type="text"
                            style={styles.input}
                            value={content.buttonUrl || ''}
                            onChange={(e) => handleUpdateBlock(block.id, { buttonUrl: e.target.value })}
                            placeholder="https://... or {{actionUrl}}"
                        />
                        <label style={styles.label}>Button Color</label>
                        <input 
                            type="color"
                            style={styles.colorInput}
                            value={content.buttonColor || '#8b5cf6'}
                            onChange={(e) => handleUpdateBlock(block.id, { buttonColor: e.target.value })}
                        />
                        <label style={styles.label}>Alignment</label>
                        <div style={styles.alignBtns}>
                            {['left', 'center', 'right'].map(align => (
                                <button
                                    key={align}
                                    style={{
                                        ...styles.alignBtn,
                                        ...(content.buttonAlign === align ? styles.alignBtnActive : {})
                                    }}
                                    onClick={() => handleUpdateBlock(block.id, { buttonAlign: align })}
                                >
                                    {align === 'left' && <FaAlignLeft />}
                                    {align === 'center' && <FaAlignCenter />}
                                    {align === 'right' && <FaAlignRight />}
                                </button>
                            ))}
                        </div>
                    </div>
                );
            case 'image':
                return (
                    <div style={styles.blockContent}>
                        <label style={styles.label}>Image URL</label>
                        <input 
                            type="text"
                            style={styles.input}
                            value={content.imageUrl || ''}
                            onChange={(e) => handleUpdateBlock(block.id, { imageUrl: e.target.value })}
                            placeholder="https://example.com/image.jpg"
                        />
                        {content.imageUrl && (
                            <img 
                                src={content.imageUrl} 
                                alt="Preview" 
                                style={styles.imagePreview}
                                onError={(e) => { e.target.style.display = 'none'; }}
                            />
                        )}
                        <label style={styles.label}>Alt Text (for accessibility)</label>
                        <input 
                            type="text"
                            style={styles.input}
                            value={content.altText || ''}
                            onChange={(e) => handleUpdateBlock(block.id, { altText: e.target.value })}
                            placeholder="Describe the image"
                        />
                        <label style={styles.label}>Width</label>
                        <select
                            style={styles.input}
                            value={content.width || '100%'}
                            onChange={(e) => handleUpdateBlock(block.id, { width: e.target.value })}
                        >
                            <option value="100%">Full Width</option>
                            <option value="75%">75%</option>
                            <option value="50%">50%</option>
                            <option value="300px">Small (300px)</option>
                        </select>
                    </div>
                );
            case 'divider':
                return (
                    <div style={styles.blockContent}>
                        <label style={styles.label}>Divider Color</label>
                        <input 
                            type="color"
                            style={styles.colorInput}
                            value={content.dividerColor || '#e5e7eb'}
                            onChange={(e) => handleUpdateBlock(block.id, { dividerColor: e.target.value })}
                        />
                    </div>
                );
            case 'spacer':
                return (
                    <div style={styles.blockContent}>
                        <label style={styles.label}>Height</label>
                        <select
                            style={styles.input}
                            value={content.height || '24px'}
                            onChange={(e) => handleUpdateBlock(block.id, { height: e.target.value })}
                        >
                            <option value="12px">Small (12px)</option>
                            <option value="24px">Medium (24px)</option>
                            <option value="40px">Large (40px)</option>
                            <option value="60px">Extra Large (60px)</option>
                        </select>
                    </div>
                );
            default:
                return null;
        }
    };

    // Template selection mode
    if (mode === 'select') {
        return (
            <div style={{ padding: '40px', maxWidth: '800px', margin: '0 auto' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
                    <div>
                        <h2 style={{ color: '#FFFFFF', margin: '0 0 8px 0' }}>Create New Template</h2>
                        <p style={{ color: 'rgba(255, 255, 255, 0.6)', margin: 0 }}>
                            Start from a pre-built template or create from scratch
                        </p>
                    </div>
                    <button style={styles.closeBtn} onClick={onClose}>
                        <FaTimes />
                    </button>
                </div>

                <h3 style={{ color: '#FFFFFF', marginBottom: '16px', fontSize: '16px' }}>Pre-built Templates</h3>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px', marginBottom: '30px' }}>
                    {PREBUILT_TEMPLATES.map(pt => (
                        <div
                            key={pt.id}
                            style={styles.prebuiltCard}
                            onClick={() => handleSelectPrebuilt(pt.id)}
                        >
                            <div style={styles.prebuiltName}>{pt.name}</div>
                            <div style={styles.prebuiltDesc}>{pt.description}</div>
                        </div>
                    ))}
                </div>

                <div style={{ 
                    display: 'flex', 
                    gap: '16px', 
                    justifyContent: 'center',
                    padding: '20px', 
                    borderTop: '1px solid rgba(255, 255, 255, 0.1)' 
                }}>
                    <button 
                        style={{ ...styles.btn, ...styles.secondaryBtn }}
                        onClick={() => {
                            setBlocks([createBlock('header', 0), createBlock('text', 1)]);
                            setEditorMode('blocks');
                            setMode('edit');
                        }}
                    >
                        <FaCubes /> Block Builder
                    </button>
                    <button 
                        style={{ ...styles.btn, ...styles.primaryBtn }}
                        onClick={() => {
                            setBlocks([]);
                            setEditorMode('html');
                            setRawHtml(HTML_STARTER_TEMPLATE);
                            setMode('edit');
                        }}
                    >
                        <FaCode /> HTML Mode
                    </button>
                </div>
            </div>
        );
    }

    // Editor mode
    return (
        <div style={styles.container}>
            {/* Sidebar - Block list and properties */}
            <div style={styles.sidebar}>
                <div style={styles.sectionTitle}>Template Info</div>
                <input 
                    type="text"
                    style={styles.input}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Template name"
                />
                <input 
                    type="text"
                    style={styles.input}
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                    placeholder="Email subject line"
                />

                {/* Editor Mode Toggle */}
                <div style={{ ...styles.sectionTitle, marginTop: '24px' }}>Editor Mode</div>
                <div style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
                    <button
                        style={{
                            flex: 1,
                            padding: '10px',
                            background: editorMode === 'blocks' ? 'rgba(139, 92, 246, 0.3)' : 'rgba(0, 0, 0, 0.3)',
                            border: editorMode === 'blocks' ? '1px solid #8b5cf6' : '1px solid rgba(255, 255, 255, 0.1)',
                            borderRadius: '6px',
                            color: editorMode === 'blocks' ? '#8b5cf6' : '#94A3B8',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '6px',
                            fontSize: '12px'
                        }}
                        onClick={() => setEditorMode('blocks')}
                    >
                        <FaCubes /> Blocks
                    </button>
                    <button
                        style={{
                            flex: 1,
                            padding: '10px',
                            background: editorMode === 'html' ? 'rgba(139, 92, 246, 0.3)' : 'rgba(0, 0, 0, 0.3)',
                            border: editorMode === 'html' ? '1px solid #8b5cf6' : '1px solid rgba(255, 255, 255, 0.1)',
                            borderRadius: '6px',
                            color: editorMode === 'html' ? '#8b5cf6' : '#94A3B8',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '6px',
                            fontSize: '12px'
                        }}
                        onClick={() => {
                            if (!rawHtml) setRawHtml(HTML_STARTER_TEMPLATE);
                            setEditorMode('html');
                        }}
                    >
                        <FaCode /> HTML
                    </button>
                </div>

                {/* BLOCK MODE SIDEBAR */}
                {editorMode === 'blocks' && (
                    <>
                        <div style={{ ...styles.sectionTitle, marginTop: '8px' }}>Add Blocks</div>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', marginBottom: '16px' }}>
                            {BLOCK_TYPES.map(({ type, icon: Icon, label }) => (
                                <div 
                                    key={type}
                                    style={{
                                        ...styles.blockType,
                                        padding: '10px',
                                        flexDirection: 'column',
                                        textAlign: 'center',
                                        gap: '6px'
                                    }}
                                    onClick={() => handleAddBlock(type)}
                                >
                                    <Icon style={{ fontSize: '18px' }} />
                                    <span style={{ fontSize: '11px' }}>{label}</span>
                                </div>
                            ))}
                        </div>

                        <div style={{ ...styles.sectionTitle, marginTop: '16px' }}>
                            Blocks ({blocks.length})
                            {selectedBlock && (
                                <span style={{ 
                                    marginLeft: '8px', 
                                    color: '#8b5cf6', 
                                    fontWeight: 'normal',
                                    textTransform: 'none'
                                }}>
                                    - Editing
                                </span>
                            )}
                        </div>
                        {blocks.length === 0 ? (
                            <p style={{ color: 'rgba(255, 255, 255, 0.5)', fontSize: '13px' }}>
                                Click on a block type above to add it
                            </p>
                        ) : (
                            blocks.sort((a, b) => a.order - b.order).map((block, index) => (
                                <div key={block.id} style={styles.blockItem}>
                                    <div 
                                        style={{
                                            ...styles.blockHeader,
                                            background: selectedBlock === block.id ? 'rgba(139, 92, 246, 0.2)' : 'rgba(0, 0, 0, 0.2)'
                                        }}
                                        onClick={() => setSelectedBlock(selectedBlock === block.id ? null : block.id)}
                                    >
                                        <span style={{ color: '#FFFFFF', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            {selectedBlock === block.id ? <FaEdit style={{ color: '#8b5cf6' }} /> : null}
                                            <span style={{ textTransform: 'capitalize' }}>{block.type}</span>
                                        </span>
                                        <div style={styles.blockActions}>
                                            <button 
                                                style={styles.iconBtn}
                                                onClick={(e) => { e.stopPropagation(); handleMoveBlock(block.id, 'up'); }}
                                                disabled={index === 0}
                                            >
                                                <FaArrowUp />
                                            </button>
                                            <button 
                                                style={styles.iconBtn}
                                                onClick={(e) => { e.stopPropagation(); handleMoveBlock(block.id, 'down'); }}
                                                disabled={index === blocks.length - 1}
                                            >
                                                <FaArrowDown />
                                            </button>
                                            <button 
                                                style={{ ...styles.iconBtn, color: '#ef4444' }}
                                                onClick={(e) => { e.stopPropagation(); handleDeleteBlock(block.id); }}
                                            >
                                                <FaTrash />
                                            </button>
                                        </div>
                                    </div>
                                    {selectedBlock === block.id && renderBlockEditor(block)}
                                </div>
                            ))
                        )}
                    </>
                )}

                {/* HTML MODE SIDEBAR */}
                {editorMode === 'html' && (
                    <div>
                        <div style={styles.placeholderHint}>
                            <strong>Available Placeholders:</strong><br/>
                            <code style={{ background: 'rgba(0,0,0,0.3)', padding: '2px 6px', borderRadius: '3px' }}>{'{{userName}}'}</code> - Recipient's name<br/>
                            <code style={{ background: 'rgba(0,0,0,0.3)', padding: '2px 6px', borderRadius: '3px' }}>{'{{expertName}}'}</code> - Your business name<br/>
                            <code style={{ background: 'rgba(0,0,0,0.3)', padding: '2px 6px', borderRadius: '3px' }}>{'{{actionUrl}}'}</code> - Action button link<br/>
                            <code style={{ background: 'rgba(0,0,0,0.3)', padding: '2px 6px', borderRadius: '3px' }}>{'{{unsubscribeLink}}'}</code> - Unsubscribe URL
                        </div>
                        
                        <div style={{ ...styles.sectionTitle, marginTop: '16px' }}>HTML Template</div>
                        <p style={{ color: 'rgba(255, 255, 255, 0.5)', fontSize: '12px', marginBottom: '12px' }}>
                            Write or paste your HTML email template. The unsubscribe footer is added automatically.
                        </p>
                        
                        <textarea
                            style={{
                                ...styles.textarea,
                                minHeight: '400px',
                                fontFamily: 'Monaco, Consolas, monospace',
                                fontSize: '12px',
                                lineHeight: '1.5',
                                whiteSpace: 'pre'
                            }}
                            value={rawHtml}
                            onChange={(e) => setRawHtml(e.target.value)}
                            placeholder="<div>Your HTML here...</div>"
                            spellCheck={false}
                        />
                    </div>
                )}
            </div>

            {/* Main Editor Area */}
            <div style={styles.editor}>
                <div style={styles.header}>
                    <h2 style={styles.headerTitle}>
                        {template ? 'Edit Template' : 'New Template'}
                    </h2>
                    <div style={styles.headerActions}>
                        <button style={{ ...styles.btn, ...styles.secondaryBtn }} onClick={handlePreview}>
                            <FaEye /> Preview
                        </button>
                        <button 
                            style={{ ...styles.btn, ...styles.primaryBtn }} 
                            onClick={handleSave}
                            disabled={saving}
                        >
                            <FaSave /> {saving ? 'Saving...' : 'Save Template'}
                        </button>
                        <button style={styles.closeBtn} onClick={onClose}>
                            <FaTimes />
                        </button>
                    </div>
                </div>

                <div style={styles.canvas}>
                    <div style={styles.emailPreview}>
                        {/* BLOCK MODE PREVIEW */}
                        {editorMode === 'blocks' && (
                            blocks.length === 0 ? (
                                <div style={{ padding: '60px 40px', textAlign: 'center', color: '#9ca3af' }}>
                                    <FaPlus style={{ fontSize: '32px', marginBottom: '16px', opacity: 0.5 }} />
                                    <p>Add blocks from the sidebar to build your email template</p>
                                </div>
                            ) : (
                                <div>
                                    {blocks.sort((a, b) => a.order - b.order).map(block => (
                                        <div
                                            key={block.id}
                                            style={{
                                                ...styles.editableBlock,
                                                ...(hoveredBlock === block.id && selectedBlock !== block.id ? styles.editableBlockHover : {}),
                                                ...(selectedBlock === block.id ? styles.editableBlockSelected : {})
                                            }}
                                            onMouseEnter={() => setHoveredBlock(block.id)}
                                            onMouseLeave={() => setHoveredBlock(null)}
                                            onClick={() => setSelectedBlock(block.id)}
                                        >
                                            <div dangerouslySetInnerHTML={{ __html: renderBlockToHtml(block) }} />
                                        </div>
                                    ))}
                                </div>
                            )
                        )}
                        
                        {/* HTML MODE PREVIEW */}
                        {editorMode === 'html' && (
                            rawHtml ? (
                                <div dangerouslySetInnerHTML={{ __html: rawHtml }} />
                            ) : (
                                <div style={{ padding: '60px 40px', textAlign: 'center', color: '#9ca3af' }}>
                                    <FaCode style={{ fontSize: '32px', marginBottom: '16px', opacity: 0.5 }} />
                                    <p>Write or paste your HTML in the sidebar to see the preview</p>
                                </div>
                            )
                        )}
                        {/* Unsubscribe footer preview */}
                        <div style={{ 
                            background: '#1f2937', 
                            color: '#9ca3af', 
                            padding: '24px', 
                            textAlign: 'center',
                            fontSize: '12px'
                        }}>
                            <p style={{ margin: '0 0 16px 0' }}>Sent by Your Business via Maven Platform</p>
                            <p style={{ margin: 0 }}>
                                Don't want to receive these emails? 
                                <a href="#" style={{ color: '#8b5cf6', marginLeft: '4px' }}>Unsubscribe</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Preview Modal */}
            {showPreview && (
                <div 
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: 'rgba(0, 0, 0, 0.9)',
                        display: 'flex',
                        flexDirection: 'column',
                        zIndex: 1001
                    }}
                >
                    <div style={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        padding: '16px 24px',
                        background: '#1e293b'
                    }}>
                        <h3 style={{ color: '#FFFFFF', margin: 0 }}>Email Preview</h3>
                        <button style={styles.closeBtn} onClick={() => setShowPreview(false)}>
                            <FaTimes />
                        </button>
                    </div>
                    <div style={{ flex: 1, overflow: 'auto', padding: '24px', display: 'flex', justifyContent: 'center' }}>
                        <iframe
                            srcDoc={`
                                <!DOCTYPE html>
                                <html>
                                <head>
                                    <style>body { margin: 0; font-family: Arial, sans-serif; }</style>
                                </head>
                                <body>
                                    <div style="background: #f3f4f6; padding: 20px;">
                                        <div style="max-width: 600px; margin: 0 auto; background: #FFFFFF; border-radius: 8px; overflow: hidden;">
                                            ${previewHtml}
                                            <div style="background: #1f2937; color: #9ca3af; padding: 24px; text-align: center; font-size: 12px;">
                                                <p style="margin: 0 0 16px 0;">Sent by Your Business via Maven Platform</p>
                                                <p style="margin: 0;">Don't want to receive these emails? <a href="#" style="color: #8b5cf6;">Unsubscribe</a></p>
                                            </div>
                                        </div>
                                    </div>
                                </body>
                                </html>
                            `}
                            style={{
                                width: '100%',
                                maxWidth: '700px',
                                height: '100%',
                                border: 'none',
                                borderRadius: '8px'
                            }}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default TemplateBuilder;
